import { get } from "../../service/api";

const GetUserCards = async (userId) => {
    try {
        const response = await get(`/user/${userId}/card`);
        return response;
    } catch (error) {
        console.error('Error GetUserCards:', error);
        throw error;
    }
};

export default GetUserCards;